import { CSSObject } from '@emotion/react'
import { Color, FontWeight, Spacing, Typeface, Typography } from '@opallabs/gem'
import { fontSizes } from '@opallabs/pulsar'
import type { StyleProps } from './types'

export const list = ({ theme }: StyleProps): CSSObject => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  blockSize: '100%',
  backgroundColor: Color[theme].Surface.N000,
})

export const header = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,
  color: Color[theme].Text.Default,
  display: 'flex',
  flexDirection: 'row',
  paddingBlock: Spacing.XS * 1.25,
  paddingInline: Spacing.M * 1.25,
  userSelect: 'none',
  fontFamily: Typeface.Default,
  fontWeight: FontWeight.Bold,
  fontSize: fontSizes.caps.small,
  textTransform: 'uppercase',
  lineHeight: '20px',
})

export const headerTitle: CSSObject = {
  marginInlineEnd: Spacing.S * 1.25,
  marginBlockStart: Spacing.XS * 0.75,
}

export const headerSubtitle = ({ theme }: StyleProps): CSSObject => ({
  ...headerTitle,
  color: Color[theme].Text.Gray,
})

export const emptyState = ({ theme }: StyleProps): CSSObject => ({
  color: Color[theme].Text.Default,
  ...Typography.T300,
  blockSize: '100%',
  inlineSize: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})
